import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './style/main.scss'
import lotteryUtil from './utils/lotteryStatus.js'
import { lotteryConfig } from "@/assets/lotteryConfig.js";
import * as filters from './filters';

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.prototype.lotteryUtil = lotteryUtil;
Vue.prototype._lotteryConfig = lotteryConfig;
Vue.prototype.$lotteryConfig = lotteryConfig;
// 引入vue2-svg-icon并且注册组件
import Icon from 'vue2-svg-icon/Icon'
Vue.component('icon',Icon);

// 全局註冊 Paginate組件
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

// 註冊全局 filter
Object.keys(filters).forEach(key => {  
	Vue.filter(key, filters[key])  
})
// filter
Object.filter = (mainObject, filterFunction)=>
    Object.keys(mainObject)
          .filter( (ObjectKey)=>filterFunction(mainObject[ObjectKey]))
          .reduce( (result, ObjectKey)=> ( result[ObjectKey] = mainObject[ObjectKey], result ), {} );

new Vue({
  router,
  store,
  lotteryUtil,
  render: h => h(App)
}).$mount('#app')